export default __webpack_public_path__ + "static/media/CFA_OneLogo.0975f8f3.jpg";